
    import "src/shared/components/ResetForm/index.module.scss?farm_css_modules";
    
    export default {"form": `form-1c6f0a71`,"formComponent": `formComponent-1c6f0a71`,"input": `input-1c6f0a71`}
    